import { render, staticRenderFns } from "./addCar.vue?vue&type=template&id=6cf8cc64&scoped=true&"
import script from "./addCar.vue?vue&type=script&lang=js&"
export * from "./addCar.vue?vue&type=script&lang=js&"
import style0 from "./addCar.vue?vue&type=style&index=0&id=6cf8cc64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf8cc64",
  null
  
)

export default component.exports